import { Component } from '@angular/core';

@Component({
  selector: 'app-data-static',
  templateUrl: './data-static.component.html',
  styleUrl: './data-static.component.scss'
})
export class DataStaticComponent {

}
